/* ==========================================
   SHARED SEARCH CONFIGURATION
========================================== */

/*
  This file contains configuration shared by:

  - custom-search.js
  - predictive-search.js

  Add commonly interchangeable search terms
  here so both search systems automatically
  use the same terminology.

  Terms inside one group are treated as
  equivalent.

  IMPORTANT:

  Do not add numeric unit variations such as
  "32A / 32 amps" here. Those are handled by
  the numeric-unit search logic.
*/


window.NXTSearchConfig = {

  termGroups: [

    [
      "water proof",
      "waterproof",
      "water-proof"
    ],

    [
      "load bank",
      "loadbank",
      "load-bank"
    ],

    [
      "ex-proof",
      "ex proof",
      "exproof",
      "explosion proof",
      "explosion-proof",
      "hazardous",
      "hazardous area",
      "hazardous location"
    ],

    [
      "multipin",
      "multi pin",
      "multi-pin"
    ],

    [
      "power lock",
      "powerlock"
    ],

    [
      "single pole",
      "singlepole",
      "single-pole"
    ],
    
        [
    "shore supply",
    "shoresupply",
    "shore-supply",
    "shore power",
    "shorepower",
    "shore-power",
    "shore connector"
  ],

  [
    "cee form",
    "ceeform",
    "cee",
    "commando plug",
  ],

  [
    "stainless steel",
    "ss",
  ],
    [
    "stainless steel 316",
    "ss316",
    "ss 316",
    "316 stainless steel",
  ],


  [
    "plug",

  ]
],

  stopWords: [
    "a",
    "an",
    "and",
    "for",
    "of",
    "the",
    "to",
    "with"
  ]

};